var map = {
	"./海報1.png": 50390,
	"./海報2.jpg": 21933,
	"./海洋科普手板(冰川融化)_2023-10-18.png": 78174,
	"./海洋科普手板(漂流霉食)_2023-10-18.png": 32496,
	"./海洋科普手板(石油漂漂)_2023-10-18.png": 90359,
	"./海洋科普手板(萬里長城)_2023-10-18.png": 39092,
	"./資料夾.png": 51617,
	"./雷雕1.jpg": 62768,
	"./雷雕2.jpg": 36197,
	"./雷雕3.jpg": 22548,
	"./雷雕4.jpg": 59726,
	"./雷雕5.jpg": 21059,
	"./雷雕6.jpg": 97685,
	"./雷雕7.jpg": 71460,
	"./雷雕8.jpg": 3806,
	"./雷雕9.jpg": 25384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62116;